import React, { createContext, useContext, useState, useCallback } from 'react';

interface TransactionContextType {
  currentTransactionIndex: number;
  setCurrentTransactionIndex: (index: number) => void;
}

const TransactionContext = createContext<TransactionContextType | undefined>(undefined);

export const TransactionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentTransactionIndex, setCurrentTransactionIndex] = useState(0);

  return (
    <TransactionContext.Provider value={{ currentTransactionIndex, setCurrentTransactionIndex }}>
      {children}
    </TransactionContext.Provider>
  );
};

export const useTransactionContext = () => {
  const context = useContext(TransactionContext);
  if (context === undefined) {
    throw new Error('useTransactionContext must be used within a TransactionProvider');
  }
  return context;
};